import {all} from '@redux-saga/core/effects';
import {watchFetchAgentUser, watchUpdateRegistrationUsername} from 'Users/ducks/agentSignUp';
import {getAgentClaimsGenerator} from 'Users/ducks/userProfile';
import {getVipUserSaga, saveVipUserSaga} from 'Users/ducks/vipUser';
import agentNumberSaga from 'Users/sagas/agentNumberSaga';
import agentSaga, {watchFetchAgents} from 'Users/sagas/agentSaga';
import agentSupportUserTypeSaga from 'Users/sagas/agentSupportUserTypeSaga';
import agentUserSaga from 'Users/sagas/agentUserSaga';
import agentUserTypeSaga from 'Users/sagas/agentUserTypeSaga';
import bosAndBeneficiariesUserSaga from 'Users/sagas/bosAndBeneficiariesUserCreationSaga';
import independentAgentRegistrationSaga from 'Users/sagas/externalUserRegistrationSaga';
import independentAgentSaga from 'Users/sagas/independentAgentSaga';
import passwordRecoverySaga from 'Users/sagas/passwordRecoverySaga';
import recruiterCodeSaga from 'Users/sagas/recruiterCodeSaga';
import ssoSaga from 'Users/sagas/SSO';
import userAdministrationSaga from 'Users/sagas/userAdministrationSaga';
import userEntrySaga from 'Users/sagas/userEntrySaga';
import userRecoverySaga from 'Users/sagas/userRecoverySaga';
import userSaga from 'Users/sagas/userSaga';
import validateSaga from 'Users/sagas/validateSaga';
import vipSaga from 'Users/sagas/vipSaga';
import getUserDetailSaga from 'Users/sagas/getUserDetailSaga';
import userProfileSaga from 'Users/sagas/userProfileSaga';
import customerSupportSaga from 'Users/sagas/CustomerSupportSaga';

export default function*() {
  yield all([
    agentNumberSaga(),
    agentSaga(),
    agentSupportUserTypeSaga(),
    agentUserSaga(),
    agentUserTypeSaga(),
    bosAndBeneficiariesUserSaga(),
    getAgentClaimsGenerator(),
    getUserDetailSaga(),
    getVipUserSaga(),
    independentAgentRegistrationSaga(),
    independentAgentSaga(),
    passwordRecoverySaga(),
    recruiterCodeSaga(),
    saveVipUserSaga(),
    ssoSaga(),
    userAdministrationSaga(),
    userEntrySaga(),
    userProfileSaga(),
    userRecoverySaga(),
    userSaga(),
    validateSaga(),
    vipSaga(),
    watchFetchAgentUser(),
    watchFetchAgents(),
    watchUpdateRegistrationUsername(),
    customerSupportSaga(),
  ]);
}
